import styled from "styled-components"

export const StyledDnD = styled.aside`
  color: ${props => props.theme.todolistBottom};
  font-size: 1.4rem;
  letter-spacing: -0.19px;
  padding-bottom: 40px;
  margin: 40px 0 0;
  text-align: center;
`
